export default class CDSUploadAdapter {
	constructor(loader) {
        // The file loader instance to use during the upload.
        this.loader = loader;
    }

    // Starts the upload process.
    upload() {
        var apiEndpoint = (process.env.NODE_ENV == 'development') ? "https://cdsapi.test:8086/" : document.location.origin + "/api/"
        return this.loader.file
            .then( file => new Promise( ( resolve, reject ) => {
				var hrefParts = window.location.href.split('/')

    		    var re = new RegExp('dashboard_token' + "=([^;]+)");
	    	    var fdToken = re.exec(document.cookie);
                console.log(fdToken[1])
                var formData = new FormData();
				formData.append('fd_token', (fdToken != null) ? unescape(fdToken[1]) : null)
				formData.append('source', 'DASHBOARD')
				formData.append('context', 'KNOWLEDGEBASE')
				formData.append('kb_item_id', hrefParts.pop())
				formData.append('upload_file', file);
				let headers = {
					method: 'post',
					body: formData,
					credentials: 'include'
				}
				fetch(apiEndpoint + 'api.php?action=upload_dashboard_image', headers).then(function(response) {
					return response.json()
				}).then(obj => {
					if (obj.image_src) {
						resolve({
		                	default: obj.image_src
			            })
						success()
					} else {
						reject(obj.message)
					}
				}).catch(error => {
					reject(error)
				})
            } ) );
    }

    // Aborts the upload process.
    abort() {
        // Do nothing???
    }
}
